import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { Button } from "@website/ui/button";
import { FALLBACK_IMAGE_MD, LazyImage } from "@website/ui/lazy-image";
import { Modal } from "@website/ui/modal";
import { useState } from "react";
import type { VillaShareTarget } from "./villa-share.utils";
import { getVillaShareTargets } from "./villa-share.utils";
export type VillaShareProperties = {
  address?: string;
  image?: string;
  shareUrl: string;
  title: string;
  villaId: number;
};
type CopyStatus = "idle" | "copied" | "error";
const WhatsappIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M19.9599 4.00809C17.8549 1.90063 15.0555 0.739517 12.0731 0.738281C5.9276 0.738281 0.926071 5.73967 0.923599 11.8868C0.922775 13.8518 1.43611 15.7701 2.41183 17.4608L0.830078 23.2383L6.74059 21.6878C8.36917 22.5762 10.2027 23.0444 12.0685 23.0449H12.0732C18.218 23.0449 23.2201 18.0431 23.2224 11.8957C23.2236 8.9165 22.065 6.1154 19.9599 4.00809ZM12.0731 21.162H12.0692C10.4064 21.1613 8.77567 20.7144 7.35266 19.8703L7.01442 19.6694L3.50703 20.5895L4.44321 17.1698L4.22279 16.8192C3.29514 15.3438 2.80528 13.6384 2.80611 11.8875C2.80803 6.77815 6.96526 2.62134 12.0768 2.62134C14.552 2.62216 16.8788 3.58731 18.6283 5.33894C20.3779 7.09058 21.3409 9.41885 21.34 11.895C21.3378 17.0048 17.1809 21.162 12.0731 21.162ZM17.1562 14.2215C16.8777 14.082 15.5079 13.4083 15.2525 13.3152C14.9974 13.2222 14.8114 13.1759 14.6259 13.4547C14.4401 13.7335 13.9063 14.3611 13.7437 14.5469C13.5811 14.7328 13.4188 14.7561 13.1401 14.6166C12.8615 14.4772 11.9639 14.1829 10.8997 13.2339C10.0716 12.4952 9.51257 11.5829 9.34998 11.3041C9.18765 11.0251 9.3486 10.8888 9.4722 10.7356C9.77377 10.3611 10.0758 9.96844 10.1686 9.78264C10.2616 9.59669 10.215 9.43396 10.1452 9.29457C10.0758 9.15518 9.51862 7.78395 9.28653 7.22598C9.06021 6.68298 8.83073 6.75632 8.65962 6.7478C8.4973 6.7397 8.31149 6.73805 8.12569 6.73805C7.94002 6.73805 7.63817 6.80768 7.38274 7.08673C7.12744 7.36565 6.40784 8.03952 6.40784 9.41075C6.40784 10.782 7.40608 12.1067 7.54533 12.2926C7.68459 12.4785 9.50983 15.2924 12.3043 16.499C12.969 16.7863 13.4878 16.9575 13.8925 17.0859C14.56 17.298 15.1671 17.268 15.6472 17.1964C16.1825 17.1163 17.2953 16.5223 17.5276 15.8717C17.7597 15.2209 17.7597 14.6632 17.69 14.5469C17.6205 14.4307 17.4347 14.3611 17.1562 14.2215Z" fill="#44D980" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const TelegramIcon = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_9686_282073)"><path d="M21.943 5.12705L18.9249 19.3605C18.6972 20.365 18.1034 20.615 17.2596 20.1418L12.6609 16.7531L10.442 18.8872C10.1964 19.1328 9.99105 19.3381 9.5178 19.3381L9.84818 14.6547L18.3713 6.9531C18.7418 6.62272 18.2909 6.43966 17.7953 6.77005L7.25867 13.4046L2.72255 11.9848C1.73585 11.6767 1.718 10.9981 2.92792 10.5248L20.6706 3.68942C21.4921 3.38135 22.2109 3.87247 21.943 5.12705Z" fill="#00B1EA" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none">{t0}<defs><clipPath id="clip0_9686_282073"><rect width="24" height="24" fill="white" /></clipPath></defs></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const XIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13.6769 10.6453L20.237 3.1875H18.6825L12.9863 9.66303L8.43678 3.1875H3.18945L10.0692 12.9797L3.18945 20.8003H4.74409L10.7594 13.962L15.564 20.8003H20.8113L13.6765 10.6453H13.6769ZM11.5476 13.0659L10.8505 12.0908L5.30424 4.33205H7.69207L12.168 10.5936L12.865 11.5687L18.6832 19.7078H16.2954L11.5476 13.0663V13.0659Z" fill="#040A1F" fillOpacity="0.87" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const BaleIcon = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_10543_119902)"><g clipPath="url(#clip1_10543_119902)"><path d="M4.81754 2.85206C5.12006 3.06024 5.41482 3.28078 5.70815 3.50315C5.73129 3.52062 5.75442 3.53809 5.77826 3.55609C5.84609 3.60736 5.91381 3.65879 5.98147 3.71032C6.00313 3.72678 6.02479 3.74324 6.0471 3.7602C6.16183 3.84816 6.27399 3.93847 6.38425 4.03266C6.40714 4.05201 6.43002 4.07135 6.4536 4.09129C6.49737 4.1285 6.54077 4.16621 6.58374 4.20444C6.60331 4.22104 6.62288 4.23764 6.64304 4.25475C6.66004 4.26966 6.67704 4.28457 6.69456 4.29993C6.75122 4.33158 6.75122 4.33158 6.82096 4.30397C6.90398 4.25751 6.97462 4.20477 7.04907 4.14414C7.21795 4.01124 7.39295 3.89913 7.57677 3.79121C7.62523 3.7627 7.62523 3.7627 7.67467 3.7336C9.80249 2.49796 12.278 2.24939 14.6006 2.96152C16.185 3.46195 17.7512 4.49427 18.7897 5.87619C18.8583 5.96681 18.9292 6.0548 19.0004 6.14304C19.3262 6.55883 19.5929 7.00825 19.839 7.48074C19.8516 7.50457 19.8643 7.52839 19.8773 7.55294C21.0073 9.68649 21.2156 12.2938 20.6077 14.6352C20.1417 16.371 19.184 18.0247 17.8755 19.1925C17.8594 19.2069 17.8432 19.2213 17.8266 19.2362C16.4619 20.4483 14.8032 21.253 13.0264 21.4654C12.99 21.4699 12.99 21.4699 12.9529 21.4745C12.6442 21.5071 12.3341 21.5047 12.0243 21.5049C11.9795 21.5049 11.9795 21.5049 11.9338 21.505C11.4783 21.5044 11.0364 21.4873 10.587 21.4023C10.557 21.3969 10.5271 21.3915 10.4962 21.3859C8.78077 21.0705 7.2289 20.2475 5.94615 19.0031C5.91762 18.9761 5.88909 18.9492 5.85969 18.9214C5.06001 18.1623 4.40825 17.1929 3.95232 16.1644C3.9323 16.1193 3.91202 16.0743 3.89154 16.0295C3.50383 15.1785 3.27068 14.2736 3.14044 13.3406C3.13569 13.3069 3.13094 13.2732 3.12605 13.2385C3.0479 12.6333 3.05592 12.0202 3.05569 11.4107C3.05557 11.3251 3.05541 11.2395 3.05525 11.1538C3.05485 10.9232 3.05466 10.6925 3.05453 10.4618C3.05445 10.3175 3.05432 10.1731 3.05419 10.0288C3.05383 9.62802 3.05352 9.22726 3.05342 8.8265C3.05341 8.80098 3.05341 8.77546 3.0534 8.74917C3.05339 8.7236 3.05339 8.69803 3.05338 8.67169C3.05337 8.61988 3.05335 8.56808 3.05334 8.51628C3.05333 8.49058 3.05333 8.46489 3.05332 8.43842C3.0532 8.02115 3.05268 7.60389 3.05199 7.18662C3.05128 6.75682 3.05091 6.32702 3.05088 5.89721C3.05085 5.65644 3.05068 5.41567 3.05014 5.1749C3.04968 4.97019 3.04953 4.76548 3.04978 4.56077C3.04989 4.45651 3.04982 4.35225 3.04945 4.24798C3.04907 4.13465 3.04924 4.02133 3.04955 3.908C3.04931 3.87551 3.04908 3.84302 3.04883 3.80954C3.051 3.46751 3.10166 3.15751 3.32823 2.90336C3.34503 2.88354 3.36182 2.86372 3.37913 2.84331C3.80661 2.39064 4.36603 2.54794 4.81754 2.85206ZM14.3045 8.67842C14.2665 8.71885 14.2284 8.75927 14.1904 8.79969C14.1091 8.88609 14.0278 8.97255 13.9465 9.05904C13.8181 9.19574 13.6896 9.33232 13.561 9.46888C13.2885 9.75838 13.0162 10.048 12.7438 10.3377C12.4489 10.6513 12.154 10.9649 11.8589 11.2783C11.7311 11.4142 11.6033 11.5501 11.4755 11.6861C11.3963 11.7704 11.3171 11.8546 11.2378 11.9388C11.2009 11.9779 11.1641 12.0171 11.1273 12.0563C11.0773 12.1097 11.0271 12.1629 10.977 12.2161C10.9623 12.2318 10.9476 12.2475 10.9325 12.2636C10.8318 12.3702 10.8318 12.3702 10.7655 12.4054C10.7584 12.3876 10.7514 12.3699 10.7441 12.3516C10.6974 12.2627 10.6407 12.2017 10.5729 12.1297C10.5314 12.0854 10.5314 12.0854 10.4892 12.0402C10.4589 12.0082 10.4286 11.9762 10.3983 11.9442C10.3671 11.911 10.3358 11.8778 10.3046 11.8446C10.2391 11.775 10.1735 11.7055 10.1078 11.6361C10.0243 11.5478 9.94107 11.4593 9.85794 11.3707C9.79342 11.302 9.72876 11.2335 9.66406 11.165C9.63337 11.1325 9.60273 11.0999 9.57213 11.0673C9.12899 10.5954 8.67548 10.2337 8.02486 10.2134C7.52743 10.2355 7.10547 10.4262 6.74937 10.7954C6.37392 11.2543 6.2733 11.7357 6.29733 12.3265C6.31023 12.5017 6.35604 12.6556 6.42213 12.8158C6.43371 12.8447 6.4453 12.8735 6.45723 12.9033C6.68932 13.4119 7.18732 13.8232 7.55806 14.2181C7.58675 14.2486 7.61543 14.2792 7.64412 14.3098C7.77882 14.4533 7.91359 14.5968 8.04845 14.7402C8.20271 14.9042 8.35671 15.0684 8.51052 15.2329C8.6305 15.3612 8.75072 15.4892 8.87111 15.6171C8.94254 15.6929 9.01388 15.7689 9.08497 15.8451C9.58439 16.4032 9.58439 16.4032 10.2151 16.7618C10.2486 16.7735 10.282 16.7852 10.3165 16.7973C10.7666 16.9324 11.2312 16.8683 11.6487 16.6493C12.0377 16.3994 12.3563 15.9942 12.6761 15.6554C12.7268 15.6018 12.7775 15.5482 12.8282 15.4946C12.9792 15.335 13.1301 15.1753 13.2809 15.0155C13.3379 14.9552 13.3948 14.8948 13.4518 14.8345C13.7036 14.5679 13.9553 14.3012 14.207 14.0345C14.2682 13.9695 14.3295 13.9046 14.3908 13.8396C14.406 13.8235 14.4212 13.8074 14.4369 13.7907C14.6839 13.5289 14.9312 13.2673 15.1786 13.0058C15.4334 12.7364 15.688 12.4668 15.9424 12.197C16.0849 12.0459 16.2275 11.8948 16.3703 11.7441C16.5045 11.6023 16.6385 11.4603 16.7723 11.3181C16.8212 11.2661 16.8703 11.2142 16.9195 11.1624C17.3571 10.7024 17.3571 10.7024 17.6338 10.1246C17.6454 10.0893 17.657 10.0539 17.6689 10.0175C17.7943 9.54472 17.7292 9.0378 17.5085 8.60819C17.2296 8.12536 16.8456 7.8375 16.3286 7.70172C15.4416 7.52135 14.8824 8.06252 14.3045 8.67842Z" fill="#0CBC8D" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <clipPath id="clip0_10543_119902"><rect width="24" height="24" fill="white" /></clipPath>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none">{t0}<defs>{t1}<clipPath id="clip1_10543_119902"><rect width="18" height="19" fill="white" transform="translate(3 2.55615)" /></clipPath></defs></svg>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const ShareTargetIcon = t0 => {
  const $ = _c(6);
  const {
    icon
  } = t0;
  if (icon === "whatsapp") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WhatsappIcon />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (icon === "bale") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <BaleIcon />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (icon === "telegram") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <TelegramIcon />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (icon === "x") {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <XIcon />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  const t1 = icon === "email" ? "mail_outline" : icon;
  let t2;
  if ($[4] !== t1) {
    t2 = <MaterialIcon name={t1} variant="outlined" />;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
const copyShareUrl = async (shareUrl: string) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(shareUrl);
    return;
  }
  const textArea = document.createElement("textarea");
  textArea.value = shareUrl;
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  textArea.style.bottom = "100%";
  document.body.append(textArea);
  textArea.select();
  const copied = document.execCommand("copy");
  textArea.remove();
  if (!copied) {
    throw new Error("Copying the villa URL failed");
  }
};
export const VillaShare = t0 => {
  const $ = _c(83);
  const {
    address,
    image,
    shareUrl,
    title,
    villaId
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [copyStatus, setCopyStatus] = useState("idle");
  let T0;
  let handleCopy;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== address || $[1] !== image || $[2] !== isOpen || $[3] !== shareUrl || $[4] !== title || $[5] !== villaId) {
    const shareTargets = getVillaShareTargets(title, shareUrl);
    const trackingProperties = {
      product: "villa" as const,
      property_id: Number(villaId) as any,
      property_name: title
    };
    const openModal = () => {
      addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_CLICKED, trackingProperties);
      setIsOpen(true);
    };
    const closeModal = () => {
      addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_MODAL_CLOSED, trackingProperties);
      setIsOpen(false);
      setCopyStatus("idle");
    };
    const handleShareTargetClick = shareChannel => {
      addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_CHANNEL_CLICKED, {
        ...trackingProperties,
        share_channel: shareChannel
      });
    };
    handleCopy = async () => {
      try {
        await copyShareUrl(shareUrl);
        addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_LINK_COPIED, trackingProperties);
        setCopyStatus("copied");
        setTimeout(() => setCopyStatus("idle"), 3000);
      } catch {
        setCopyStatus("error");
      }
    };
    let t18;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <MaterialIcon name="share" variant="outlined" />;
      $[25] = t18;
    } else {
      t18 = $[25];
    }
    t16 = <Button aria-label={"\u0627\u0634\u062A\u0631\u0627\u06A9 \u06AF\u0630\u0627\u0631\u06CC \u0627\u06CC\u0646 \u0648\u06CC\u0644\u0627"} className="!hidden md:!flex" color="neutral" onClick={openModal} size="small" StartIcon={t18} variant="text">اشتراک گذاری</Button>;
    let t19;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <MaterialIcon name="share" variant="outlined" />;
      $[26] = t19;
    } else {
      t19 = $[26];
    }
    if ($[27] !== openModal) {
      t17 = <Button aria-label={"\u0627\u0634\u062A\u0631\u0627\u06A9 \u06AF\u0630\u0627\u0631\u06CC \u0627\u06CC\u0646 \u0648\u06CC\u0644\u0627"} className="!absolute left-4 top-4 z-10 !flex !bg-white shadow md:!hidden" color="transparent" equalDimension={true} onClick={openModal} StartIcon={t19} />;
      $[27] = openModal;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    T0 = Modal;
    t7 = "bottom";
    t8 = "lg:!w-[460px]";
    t9 = "auto";
    t10 = closeModal;
    t11 = isOpen;
    t12 = true;
    t13 = "!text-[24px] !text-on-surface-medium-emphasis";
    t14 = "\u0627\u0634\u062A\u0631\u0627\u06A9 \u06AF\u0630\u0627\u0631\u06CC \u0627\u06CC\u0646 \u0648\u06CC\u0644\u0627";
    t15 = "!text-headline-6 !font-[500]";
    t4 = "mt-6 flex flex-col gap-4";
    t5 = "rtl";
    let t20;
    if ($[29] !== image || $[30] !== title) {
      t20 = <LazyImage alt={title} className="!h-[55px] !w-[66px] shrink-0 rounded-xl md:!h-[83px] md:!w-[100px]" fallback={FALLBACK_IMAGE_MD.src} height={83} src={image} width={100} />;
      $[29] = image;
      $[30] = title;
      $[31] = t20;
    } else {
      t20 = $[31];
    }
    let t21;
    if ($[32] !== title) {
      t21 = <p className="text-body-2 line-clamp-2 !font-[700]">{title}</p>;
      $[32] = title;
      $[33] = t21;
    } else {
      t21 = $[33];
    }
    let t22;
    if ($[34] !== address) {
      t22 = address ? <div className="text-on-surface-medium-emphasis text-caption mt-2 flex items-center gap-1"><MaterialIcon name="location_on" className="text-[16px]" variant="outlined" /><span className="text-extra-caption truncate !font-[400]">{address}</span></div> : null;
      $[34] = address;
      $[35] = t22;
    } else {
      t22 = $[35];
    }
    let t23;
    if ($[36] !== t21 || $[37] !== t22) {
      t23 = <div className="min-w-0 flex-1">{t21}{t22}</div>;
      $[36] = t21;
      $[37] = t22;
      $[38] = t23;
    } else {
      t23 = $[38];
    }
    if ($[39] !== t20 || $[40] !== t23) {
      t6 = <div className="flex items-start gap-3">{t20}{t23}</div>;
      $[39] = t20;
      $[40] = t23;
      $[41] = t6;
    } else {
      t6 = $[41];
    }
    t3 = "";
    t1 = "grid grid-cols-5 gap-2";
    t2 = shareTargets.map(t24 => {
      const {
        href,
        icon,
        label,
        openInNewTab: shouldOpenInNewTab
      } = t24;
      return <a aria-label={`اشتراک گذاری با ${label}`} className="text-caption text-on-surface-high-emphasis flex min-w-0 flex-col items-center gap-2 no-underline" href={href} key={icon} onClick={() => handleShareTargetClick(icon)} rel={shouldOpenInNewTab ? "noopener noreferrer" : undefined} target={shouldOpenInNewTab ? "_blank" : undefined}><span className={`flex size-14 items-center justify-center rounded-full bg-[#F8F9FD] text-2xl hover:bg-[#EBECF2] lg:size-14 ${icon === "whatsapp" || icon === "sms" ? "text-[#44D980]" : icon === "telegram" ? "text-[#00B1EA]" : "text-on-surface-high-emphasis"}`}><ShareTargetIcon icon={icon} /></span><span className="text-extra-caption truncate font-normal">{label}</span></a>;
    });
    $[0] = address;
    $[1] = image;
    $[2] = isOpen;
    $[3] = shareUrl;
    $[4] = title;
    $[5] = villaId;
    $[6] = T0;
    $[7] = handleCopy;
    $[8] = t1;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t13;
    $[13] = t14;
    $[14] = t15;
    $[15] = t16;
    $[16] = t17;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    T0 = $[6];
    handleCopy = $[7];
    t1 = $[8];
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t13 = $[12];
    t14 = $[13];
    t15 = $[14];
    t16 = $[15];
    t17 = $[16];
    t2 = $[17];
    t3 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t18;
  if ($[42] !== t1 || $[43] !== t2) {
    t18 = <div className={t1}>{t2}</div>;
    $[42] = t1;
    $[43] = t2;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t18 || $[46] !== t3) {
    t19 = <div className={t3}>{t18}</div>;
    $[45] = t18;
    $[46] = t3;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== shareUrl) {
    t20 = <input aria-label={"\u0644\u06CC\u0646\u06A9 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"} className="text-body-2 min-w-0 flex-1 text-left outline-none" dir="ltr" id="villa-share-url" readOnly={true} value={shareUrl} />;
    $[48] = shareUrl;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const t21 = copyStatus === "copied" ? "\u06A9\u067E\u06CC \u0634\u062F!" : "\u06A9\u067E\u06CC \u0644\u06CC\u0646\u06A9";
  let t22;
  if ($[50] !== handleCopy || $[51] !== t21) {
    t22 = <Button aria-label={"\u06A9\u067E\u06CC \u0644\u06CC\u0646\u06A9 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"} onClick={handleCopy} color="secondary">{t21}</Button>;
    $[50] = handleCopy;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t20 || $[54] !== t22) {
    t23 = <div className="border-outline-thin flex gap-2 rounded-lg border p-2">{t20}{t22}</div>;
    $[53] = t20;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== copyStatus) {
    t24 = copyStatus === "error" ? <p className="text-error text-caption" role="alert">کپی لینک انجام نشد. لطفا دوباره تلاش کنید.</p> : null;
    $[56] = copyStatus;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== t23 || $[59] !== t24) {
    t25 = <div className="flex flex-col gap-2">{t23}{t24}</div>;
    $[58] = t23;
    $[59] = t24;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t19 || $[62] !== t25 || $[63] !== t4 || $[64] !== t5 || $[65] !== t6) {
    t26 = <div className={t4} dir={t5}>{t6}{t19}{t25}</div>;
    $[61] = t19;
    $[62] = t25;
    $[63] = t4;
    $[64] = t5;
    $[65] = t6;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  let t27;
  if ($[67] !== T0 || $[68] !== t10 || $[69] !== t11 || $[70] !== t12 || $[71] !== t13 || $[72] !== t14 || $[73] !== t15 || $[74] !== t26 || $[75] !== t7 || $[76] !== t8 || $[77] !== t9) {
    t27 = <T0 animate={t7} className={t8} mobileHeight={t9} onClose={t10} open={t11} showCloseButton={t12} iconClassName={t13} title={t14} titleClassName={t15}>{t26}</T0>;
    $[67] = T0;
    $[68] = t10;
    $[69] = t11;
    $[70] = t12;
    $[71] = t13;
    $[72] = t14;
    $[73] = t15;
    $[74] = t26;
    $[75] = t7;
    $[76] = t8;
    $[77] = t9;
    $[78] = t27;
  } else {
    t27 = $[78];
  }
  let t28;
  if ($[79] !== t16 || $[80] !== t17 || $[81] !== t27) {
    t28 = <>{t16}{t17}{t27}</>;
    $[79] = t16;
    $[80] = t17;
    $[81] = t27;
    $[82] = t28;
  } else {
    t28 = $[82];
  }
  return t28;
};